import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { IonicPageModule } from 'ionic-angular';
import { TabsSf7Page } from './tabs-sf7';

@NgModule({
  declarations: [
    TabsSf7Page,
  ],
  imports: [
    IonicPageModule.forChild(TabsSf7Page),
    FlexLayoutModule,
    AngularSvgIconModule,
    TranslateModule
  ],
  exports: [TabsSf7Page]
})
export class TabsSf7PageModule {}



// WEBPACK FOOTER //
// ./src/pages/sf7/components/tabs-sf7/tabs-sf7.module.ts